import {createAction} from "@reduxjs/toolkit";

export const closeModal = createAction('CLOSE_MODAL');